import styled from '@emotion/styled';
import { Box, Paper } from '@mui/material';

export const Container = styled(Paper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  border-radius: 16px;
  background: #1a1a2e;
`;

export const VideoContainer = styled(Box)`
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  overflow: hidden;
  background: #0f0f1a;
`;

export const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const StatusBar = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 16px;
  background: ${props => props.theme.palette.primary.main};
  color: ${props => props.theme.palette.primary.contrastText};
`;

export const FeedbackContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 1;
  padding: 24px;
  text-align: center;
  background: #0f0f1a;
  gap: 16px;
`;

export const IconWrapper = styled(Box)<{ variant?: 'error' | 'warning' | 'info' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: ${props => {
    switch (props.variant) {
      case 'error':
        return 'rgba(244, 67, 54, 0.15)';
      case 'warning':
        return 'rgba(255, 152, 0, 0.15)';
      default:
        return 'rgba(0, 217, 255, 0.15)';
    }
  }};

  svg {
    font-size: 32px;
    color: ${props => {
      switch (props.variant) {
        case 'error':
          return '#f44336';
        case 'warning':
          return '#ff9800';
        default:
          return '#00d9ff';
      }
    }};
  }
`;
